<template>
  <div class="sign-in">
    <!-- <h1>扫码登录</h1>
    <h2>Scan the qr code to log in</h2>-->
    <div class="qr-corner" @click="goSign">
      <img src="../../assets/info-corner.png" alt>
    </div>
    <div class="qr-sign-in-form form-wrap">
      <wxlogin :appid="wxAppId" :scope="wxScope" :redirect_uri="wwwURL" :href="cssHref"></wxlogin>
      <button class="login-btn" @click="goSign">
        <span>使用手机号{{signType === 'up'?'注册':'登录'}}</span>
        <img src="../../assets/arrow.png" alt>
      </button>
    </div>
  </div>
</template>
<script>
import ENV from '@/config/env.config'
import wxlogin from 'vue-wxlogin'

export default {
  name: 'qrSignIn',
  data() {
    return {
      qrLink: '',
      wxAppId: ENV.wxAppId,
      wxScope: ENV.wxScope,
      wwwURL: ENV.wwwURL, // 微信只支持绝对地址
      cssHref: ENV.qrcssUrl,
      signType: this.$route.query.signType || 'in' // in登录，up注册
    }
  },
  components: {
    wxlogin
  },
  methods: {
    goSign() {
      let path = this.signType === 'up' ? '/login/sign-up' : '/login'
      this.$router.push({ path })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
